import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowUpRight, Lightbulb } from 'lucide-react';
import { RuleCallout } from './RuleCallout';
import { ManualShot } from './ManualShot';

export const TileArticle = ({ tile, full, theme }) => {
  const navigate = useNavigate();
  return (
    <article id={`tile-${tile.id}`} data-testid={`help-tile-${tile.id}`} className="rounded-xl border border-gray-200 bg-white p-4 sm:p-5 break-inside-avoid scroll-mt-28">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h4 className="text-base font-bold text-[#27292E]">{tile.title}</h4>
          <p className="text-sm text-gray-600 mt-0.5">{tile.what}</p>
        </div>
        {tile.route && (
          <button type="button" onClick={() => navigate(tile.route)} data-testid={`help-open-${tile.id}`} className={`no-print shrink-0 inline-flex items-center gap-1 text-xs font-semibold ${theme.text} hover:underline`}>
            Open <ArrowUpRight className="w-3.5 h-3.5" />
          </button>
        )}
      </div>

      {tile.quick?.length > 0 && (
        <div className="mt-3">
          <div className="text-[11px] font-bold uppercase tracking-wide text-gray-500">Quick reference</div>
          <ul className="mt-1.5 space-y-1 text-sm text-gray-800 list-disc pl-5">
            {tile.quick.map((q, i) => <li key={i}>{q}</li>)}
          </ul>
        </div>
      )}

      {tile.shot !== false && <ManualShot id={tile.id} title={tile.title} />}

      {full && tile.detail?.map((d, i) => (
        <div key={i} className="mt-4">
          <div className="text-sm font-semibold text-[#27292E]">{d.heading}</div>
          <ol className="mt-1.5 space-y-1.5 text-sm text-gray-800 list-decimal pl-5">
            {d.steps.map((s, j) => <li key={j}>{s}</li>)}
          </ol>
        </div>
      ))}

      {full && tile.tips?.length > 0 && (
        <div className="mt-4 flex gap-2 rounded-lg bg-slate-50 border border-slate-200 px-3 py-2.5 text-sm text-slate-700">
          <Lightbulb className="w-4 h-4 shrink-0 mt-0.5 text-slate-500" />
          <div>{tile.tips.map((t, i) => <p key={i}>{t}</p>)}</div>
        </div>
      )}

      {tile.rules?.length > 0 && (
        <div className="mt-4 space-y-2">
          {tile.rules.map((r) => <RuleCallout key={typeof r === 'string' ? r : r.slice(0, 20)} rule={r} compact={!full} />)}
        </div>
      )}
    </article>
  );
};
